import { useQuery } from "convex/react"
import { api } from "../../../convex/_generated/api"
import type { Id } from "../../../convex/_generated/dataModel"
import { AdminPersonLine } from "@/components/admin/admin-person-line"
import { StatusPill } from "@/components/status-pill"
import { Skeleton } from "@/components/ui/skeleton"

function appliedOn(appliedAt: number) {
  return new Date(appliedAt).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  })
}

export function AdminJobApplicants({ jobId }: { jobId: Id<"jobs"> }) {
  const applicants = useQuery(api.admin.listJobApplicants, { jobId })

  if (applicants === undefined) {
    return <Skeleton className="mt-4 h-16 w-full" />
  }

  if (applicants.length === 0) {
    return (
      <p className="mt-4 text-sm text-[color:var(--wf-mute)]">
        No applications recorded for this job.
      </p>
    )
  }

  return (
    <ul className="mt-4 space-y-3 border-t border-[color:var(--wf-line)] pt-4">
      {applicants.map((applicant) => (
        <li key={applicant._id} className="text-sm">
          <div className="flex flex-wrap items-center gap-2">
            {applicant.piiSuppressed ? (
              <span className="font-medium text-[color:var(--wf-ink)]">
                {applicant.seekerName}
              </span>
            ) : (
              <AdminPersonLine
                name={applicant.seekerName}
                email={applicant.seekerEmail}
                linkedinUrl={applicant.linkedinUrl}
              />
            )}
            <StatusPill domain="application" status={applicant.status} as="badge" />
            <span className="text-[color:var(--wf-mute)]">
              {appliedOn(applicant.appliedAt)}
            </span>
          </div>
          {applicant.seekerHeadline ? (
            <p className="mt-0.5 text-[color:var(--wf-mute)]">
              {applicant.seekerHeadline}
            </p>
          ) : null}
          {applicant.coverNote ? (
            <p className="mt-1 line-clamp-2 text-[color:var(--wf-mute)]">
              {applicant.coverNote}
            </p>
          ) : null}
        </li>
      ))}
    </ul>
  )
}
